import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiAddressService } from './api.address.service';
import { LoginService } from './login.service';
import { OnInit } from '@angular/core';
import { SharedFunctionService } from './shared.function.service';
import { ApiService } from './api.service';
import { Group } from '../models/IGA-group/group.model';
import { GroupMember } from '../models/IGA-group/group-member.model';

@Injectable({
  providedIn: 'root',
})
export class GroupMembersService implements OnInit {
  private http = inject(HttpClient);
  private apiAddressService = inject(ApiAddressService);
  private loginService = inject(LoginService);
  private sharedFunction = inject(SharedFunctionService);
  private apiService = inject(ApiService);


  ngOnInit(): void {
    this.loginService.checkLoginStatus();
  }

  // internal group admin: get available groups
  getAvailableGroups(callback: (data: Group[]) => void) {
    this.apiService.callApi<Group[]>('', this.apiAddressService.getAvailableGroupsUrl(), (response) => {
      callback(response);
    });
  }

  // internal group admin: get group members
  getGroupMembers(groupId: number, callback: (data: GroupMember[]) => void) {
    this.apiService.callApi<GroupMember[]>('', this.apiAddressService.getGroupMembersUrl(groupId), (response) => {
      callback(response);
    });
  }
}
